import React from "react";


const KHeader = () =>{

    return(
        <>
        <div className="header">
        <img src="https://www.freepnglogos.com/uploads/camera-logo-png/photography-clipart-camera-logo-pencil-color-6.png" alt="logo" width="70" height="50"/>
        <h1>Sharad Notes</h1>
        </div>
        </>
    )
}
export default KHeader;